module.exports = __webpack_public_path__ + "e19.no2.55ed39b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e19.no2.jpg
// module id = RREp
// module chunks = 0